import { Filter as FilterComponent } from "./Filter";
import { FilterChip } from "./FilterChip";
import { FilterPopover } from "./FilterPopover";

export const Filter = Object.assign(FilterComponent, {
  Chip: FilterChip,
  Popover: FilterPopover,
});
